import React from "react";

import { EMPTY_STRING } from "../../../constants";
import { PRODUCT_TYPES_ENUMS } from "../../../system/globalEnums";
import SelectDropdownFormik from "../selectDropdown/SelectDropdownFormik";
import {
  handleOnChangeTradingCardLanguage,
  isTcgPlayerApi,
} from "../../utility";

const SelectLanguage = (props) => {
  const {
    isFormik = true,
    value,
    setFieldValue,
    label = EMPTY_STRING,
    priceChartingProductInfo: { productMetaData },
    priceChartingProductInfo,
    setPriceChartingProductInfo = () => {},
    setPriceChartingProductInfoComponent = () => {},
  } = props;

  const handleLanguageChange = (...props) => {
    //if user selects the already selected one return
    if (productMetaData.language === props[1]) {
      return;
    }
    setFieldValue(...props);
    let updatedPriceChartingProductInfo = handleOnChangeTradingCardLanguage(
      props[1],
      priceChartingProductInfo
    );
    setPriceChartingProductInfo({ ...updatedPriceChartingProductInfo });
    setPriceChartingProductInfoComponent({
      ...updatedPriceChartingProductInfo.productMetaData,
    });
  };

  return (
    isTcgPlayerApi(productMetaData) &&
    (isFormik ? (
      <>
        {label && <label className="field-label">{label}</label>}
        <SelectDropdownFormik
          name="language"
          value={productMetaData?.language}
          setFieldValue={handleLanguageChange}
          options={productMetaData?.languageList ?? []}
        />
      </>
    ) : null)
  );
};

export default SelectLanguage;
